import { BaseComponent, IBaseProps, IBaseStates } from "../../components/infrastructure/baseComponent";
import CustomSpinner from "../../components/infrastructure/customSpinner";
import { ICallOptions, IResultSet } from "../../components/infrastructure/models";
import { PdfViewer } from "../../components/pdfViewer";

export interface IDamageCaseSummaryProps extends IBaseProps {
    damageCaseId: number;
    invoker: 'damagecasevoucherpaymentdraft' | 'damagecaseevaluator'
}

export interface IDamageCaseSummaryStates extends IBaseStates {
    pdfBase64String: string;
}

export class DamageCaseSummary extends BaseComponent<IDamageCaseSummaryProps, IDamageCaseSummaryStates>{
    constructor(props: IDamageCaseSummaryProps) {
        super(props)
        this.state = {
            isAuthorized: true,
            loading: true,
            windowSize: window.innerWidth <= 765 ? 1 : 2,
            pdfBase64String: ''
        };
    }
    componentDidMount() {
        super.componentDidMount();
        this.printDamageCaseSummary();
    }
    printDamageCaseSummary = async () => {
        const { damageCaseId, invoker } = this.props;
        let fetchOpt: ICallOptions = {
            url: `${invoker}/printdamagecasesummary`,
            data: { damageCaseId },
            onSuccess: res => {
                if (res.ValidationState.Successful)
                    this.setState({ pdfBase64String: (res as IResultSet<string>).Data! });
            }
        };
        await this.callApi(fetchOpt);
    }
    virtualRender() {
        const header = this.getPageHeader({
            title: "خلاصه پرونده خسارت",
            onBack: () => {
                if (this.props.onClose && this.mounted)
                    this.props.onClose(this);
                else
                    window.history.back();
            }
        });

        const { pdfBase64String } = this.state;

        return (
            <>
                {header}
                {this.state.loading ?
                    <CustomSpinner />
                    :
                    <div style={{ height: 'calc(100vh - 240px)' }}>
                        <PdfViewer url={pdfBase64String ? `data:application/pdf;base64,${pdfBase64String}` : ''} />
                    </div>
                }
            </>
        );
    }
}